import { useEffect, useCallback } from 'react'
import Router, { useRouter } from 'next/router'
import NProgress from 'nprogress'

import { matchPath } from 'lib/utils'

import { SEARCH_ROUTE } from 'lib/constants/routes'

import { useGlobalContext } from './global-context'
import { useAppData } from './app-data-context'

export function ProgressBar() {
  const router = useRouter()
  const { isMobileView } = useGlobalContext()
  const isSearchRoute = matchPath(router.asPath, SEARCH_ROUTE)

  const {
    partnerFeatureControl: { showFeature },
  } = useAppData()

  const routeChangeStart = useCallback(
    (url) => {
      if (isMobileView && !showFeature('progressbar')) {
        return
      }

      const pathWithLocale = `/${router.locale}${router.asPath}`
      if (url === pathWithLocale) {
        return
      }

      NProgress.start()
    },
    [isMobileView, showFeature, router.locale, router.asPath]
  )

  const routeChangeEnd = useCallback(() => {
    if (isMobileView && !showFeature('progressbar')) {
      return
    }
    // Disable done for search route as it will be handled by search route itself
    if (!isSearchRoute) {
      NProgress.done()
    }
  }, [isMobileView, showFeature, isSearchRoute])

  const routeChangeError = useCallback(() => {
    NProgress.done()
  }, [])

  useEffect(() => {
    NProgress.configure({ showSpinner: false })

    Router.events.on('routeChangeStart', routeChangeStart)
    Router.events.on('routeChangeComplete', routeChangeEnd)
    Router.events.on('routeChangeError', routeChangeError)
    return () => {
      Router.events.off('routeChangeStart', routeChangeStart)
      Router.events.off('routeChangeComplete', routeChangeEnd)
      Router.events.off('routeChangeError', routeChangeError)
    }
  }, [routeChangeStart, routeChangeEnd, routeChangeError])

  return null
}
